import {
  BFF_ROUTES,
  CardOnFileResponseSchema,
  DepositConfirmResponseSchema,
  DepositIntentResponseSchema,
  WaiverElectionResponseSchema,
  type CardOnFileRequest,
  type CardOnFileResponse,
  type DepositConfirmRequest,
  type DepositConfirmResponse,
  type DepositIntentRequest,
  type DepositIntentResponse,
  type WaiverElectionRequest,
  type WaiverElectionResponse,
} from '@rheora/enrollment-contract';

import { bffPost } from './bff-client';

/**
 * Typed fetchers for the E-SF05 deposit step (AC2). Thin: POST + validate against
 * the shared contract schema. Pages call the `deposit.queries` hooks, never these.
 *
 * SAQ-A: no card data is ever sent through these — the intent returns the Stripe
 * publishable key + client token, and the card is tokenised in the browser by
 * Stripe Elements. The confirm sends only the Stripe PaymentIntent id.
 */
export async function postDepositIntent(
  request: DepositIntentRequest,
): Promise<DepositIntentResponse> {
  return bffPost(BFF_ROUTES.depositIntent, request, DepositIntentResponseSchema);
}

export async function postDepositConfirm(
  request: DepositConfirmRequest,
): Promise<DepositConfirmResponse> {
  return bffPost(BFF_ROUTES.depositConfirm, request, DepositConfirmResponseSchema);
}

/**
 * Put a MASKED card on file with no Stripe (dev/demo). The `card` here is ALREADY
 * masked ({brand,last4,expMonth,expYear}) — `deriveMaskedCard` produced it in the
 * browser and the full PAN/CVV were discarded. Only the masked descriptor is sent.
 */
export async function postCardOnFile(request: CardOnFileRequest): Promise<CardOnFileResponse> {
  return bffPost(BFF_ROUTES.depositCardOnFile, request, CardOnFileResponseSchema);
}

/** Record a §25.478 waiver election in lieu of paying the deposit (AC1 / AC2). */
export async function postWaiverElection(
  request: WaiverElectionRequest,
): Promise<WaiverElectionResponse> {
  return bffPost(BFF_ROUTES.depositWaiverElection, request, WaiverElectionResponseSchema);
}
